// 계약 고객 링크 액션(rpc) — 첫 인자(또는 input.token)는 주소의 토큰과 같아야 한다(서버가 맞춰 본다).
import { shareRpc } from "@/api/client";

export const verifyContractShare = (token: string, last4: string) => shareRpc("c", token, "verifyContractShare", token, last4);

export const signContractByLink = (input: { token: string; name: string; agree: boolean }) =>
  shareRpc("c", input.token, "signContractByLink", input);
